import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
import { ThemeProvider } from "./context/ThemeContext"
import { AuthProvider } from "./context/AuthContext"
import PublicRoute from "./components/PublicRoute"
import PrivateRoute from "./components/PrivateRoute"
import AuthScreen from "./components/AuthScreen"


import 'bootstrap/dist/css/bootstrap.min.css';
import "react-phone-input-2/lib/style.css";
import "./App.css"

import Dashboard from "./pages/Dashboard"
import { BlurProvider } from "./context/BlurContext"
import { store } from './redux/store'
import { Provider } from "react-redux"
import ResetPassword from "./pages/ResetPassword"
import Layout from "./layout"
import RangoExchange from "./pages/RangoExchange"
import ActivityView from "./components/ActivityView"
import NFTView from "./components/NFTView"
import DAppsView from "./components/DAppsView"
import SettingsView from "./components/SettingsView"
import UserSessions from "./pages/UserSessions"
import OnRamp from "./pages/OnRamp"
import OffRamp from "./pages/OffRamp"
import DepositCurrency from "./pages/DepositCurrency"
import ToastWrapper from "./HOC/ToastWrapper"
import History from "./pages/History"
import CoinDetails from "./pages/CoinDetails"
import SessionCheck from "./pages/SessionCheck"
import SessionConflictScreen from "./components/SessionConflictScreen"

function App() {
  return (
    <Provider store={store}>
      <ToastWrapper />
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <BlurProvider>
              <Routes>
                {/* Public Routes - Only accessible when NOT logged in */}
                <Route
                  path="/login"
                  element={
                    <PublicRoute>
                      <AuthScreen />
                    </PublicRoute>
                  }
                />
                <Route
                  path="/register"
                  element={
                    <PublicRoute>
                      <AuthScreen />
                    </PublicRoute>
                  }
                />
                <Route
                  path="/forgot-password"
                  element={
                    <PublicRoute>
                      <AuthScreen />
                    </PublicRoute>
                  }
                />
                <Route
                  path="/verify-otp"
                  element={
                    <PublicRoute>
                      <AuthScreen />
                    </PublicRoute>
                  }
                />

                {/* Private Routes - Only accessible when logged in */}
                <Route
                  path="/dashboard"
                  element={
                    <PrivateRoute>
                      <Layout >
                        <Dashboard />
                      </Layout>
                    </PrivateRoute>
                  }
                />
                 <Route 
                  path="/coin/:chainId/:coinId" 
                  element={
                    <PrivateRoute>
                      <Layout >
                        <CoinDetails />
                      </Layout>
                    </PrivateRoute>
                  } 
                />
                <Route
                  path="/activity/:id"
                  element={
                    <PrivateRoute>
                      <Layout>
                        <ActivityView />
                      </Layout>
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/dashboard/nfts"
                  element={
                    <PrivateRoute>
                      <Layout>
                        <NFTView />
                      </Layout>
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/dashboard/dapps"
                  element={
                    <PrivateRoute>
                      <Layout>
                        <DAppsView />
                      </Layout>
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/dashboard/settings"
                  element={
                    <PrivateRoute>
                      <Layout>
                        <SettingsView />
                      </Layout>
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/rango-exchange"
                  element={
                    <PrivateRoute>
                      <Layout>
                        <RangoExchange />
                      </Layout>
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/reset-password"
                  element={
                    <PrivateRoute>
                      <Layout>
                        <ResetPassword />
                      </Layout>
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/user-sessions"
                  element={
                    <PrivateRoute>
                      <Layout>
                        <UserSessions />
                      </Layout>
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/on-ramping"
                  element={
                    <PrivateRoute>
                      <Layout>
                        <OnRamp />
                      </Layout>
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/off-ramping"
                  element={
                    <PrivateRoute>
                      <Layout>
                        <OffRamp />
                      </Layout>
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/dashboard/deposit-currency"
                  element={
                    <PrivateRoute>
                      <Layout>
                        <DepositCurrency />
                      </Layout>
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/history"
                  element={
                    <PrivateRoute>
                      <Layout>
                        <History />
                      </Layout>
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/session-check"
                  element={
                    <PrivateRoute>
                      <SessionCheck />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/session-conflict"
                  element={
                    <PrivateRoute>
                      <SessionConflictScreen />
                    </PrivateRoute>
                  }
                />

                {/* Default redirects */}
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </BlurProvider>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
      <ToastWrapper />
    </Provider>
  )
}

export default App
